// extracted by mini-css-extract-plugin
export default {"categories_container":"CategoriesList_categories_container__C0zpJ"};